<form *ngIf="config !== null">
  <eas-translation-section
    *ngFor="let section of config; let sectionIndex = index"
    [section]="section"
    [sectionForm]="getSectionForm(sectionIndex)"
    [originalLanguage]="originalLanguage"
    [translationLanguage]="translationLanguage"
  ></eas-translation-section>
  <button type="submit" mat-flat-button color="primary" (click)="onSave()" i18n>Save</button>
</form>
